module.exports = __webpack_public_path__ + "img/044.558b0d33.png";